import { createContext, useContext } from 'react';
import { type UseFormReturnType } from '@mantine/form';

export interface EditorContextValue<TFormType> {
    form: UseFormReturnType<TFormType>;
    mode: 'create' | 'update';
    loading: boolean;
    onSave: () => Promise<boolean | void>;
}

// Create the context with a generic type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EditorContext = createContext<EditorContextValue<any> | null>(null);

// Hook to use the context
export function useEditorContext<TFormType>(): EditorContextValue<TFormType> {
    const context = useContext(EditorContext);

    if (!context) {
        throw new Error('useEditorContext must be used within an EditorProvider');
    }

    return context as EditorContextValue<TFormType>;
}
